<template>
    <crud-facecade
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        v-wechat-title="title"
        :tableHeight="tableHeight"
        :addButton="{ permission: 'drug_unit:create' }"
        :deleteButton="{ permission: 'drug_unit:delete' }"
        :updateButton="{ permission: 'drug_unit:update' }"
    >
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `DrugUnit`,
    props: {},
    data() {
        return {
            title: `基础数据-药品单位`,
            url: { baseURL: `/api/AcisSystem/DrugUnit` },
            buttons: []
        }
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    // width: "180",
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    readonly: false,
                    sortable: true,
                    isDisplayOrder: true
                },
                // {
                //   type: "string",
                //   prop: "code",
                //   label: "编码",
                //   width: "180",
                //   isListable: false,
                //   isExpand: false,
                //   isEditable: true,
                //   isCreatable: true,
                //   searchable: false,
                //   sortable: false,
                //   validate: [{required: true, message: '必填项目', trigger: 'blur'}]
                // },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `rbool`,
                    prop: `is_deleted`,
                    label: `状态`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: false,
                    readonly: false,
                    options: `is_enabled`,
                    default: false
                },
                {
                    type: `select`,
                    prop: `is_speed_unit`,
                    label: `是否流速`,
                    width: `160`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: false,
                    change: (that, { row }) => {
                        if (row.is_speed_unit) {
                            row.is_concentration_unit = false
                        }
                    }
                },
                {
                    type: `select`,
                    prop: `is_concentration_unit`,
                    label: `是否浓度`,
                    width: `160`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: false,
                    change: (that, { row }) => {
                        if (row.is_concentration_unit) {
                            row.is_speed_unit = false
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `speed_to_dose_expression`,
                    label: `通过流量求用量计算表达式`,
                    width: `200`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false
                },
                {
                    type: `string`,
                    prop: `dose_to_speed_expression`,
                    label: `通过用量反推流量计算表达式`,
                    width: `200`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false
                },
                {
                    type: `string`,
                    prop: `expression_description`,
                    label: `计算表达式描述`,
                    width: `200`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false
                }
            ]
        }
    },
    mounted() {},
    methods: {}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Drug/DrugUnit.vue